import {ErrorInfo} from 'react'
import { APIResponse } from '../../../server/routes/route-types.js';
import { ReportClientErrorParams, ReportClientErrorResult } from '../../../server/routes/main.js';

// interface ErrorInfo {
//     [key: string]: unknown;
// }

export function reportError (url: string, error: Error, errorInfo: ErrorInfo): void {

    const jsonBody: ReportClientErrorParams = {
            url: url,
            errorMessage: error.message,
            errorStack: JSON.stringify(error.stack),
            errorInfo: JSON.stringify(errorInfo),
    }

    fetch( "/report-client-error", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(jsonBody)
    }).then(( response ) => {
        return response.json();
    }).then(( untypedResponse: unknown ) => {
        const response = untypedResponse as APIResponse<ReportClientErrorResult>;
        if (response.err) {
            console.log(`Unexpected error from server reporting client error: ${response.err}`);
        }
    }).catch(( e ) => {
        console.log(`Unexpected error reporting client error: ${e.stack}`);
    });
}
